module.exports = __webpack_public_path__ + "static/media/Cleo.73d1fec5.png";